import React from 'react'
import DetailsLoader from '../../Forms/DetailsLoader'
import { RMADetailLoaderContainer } from '../../style/RMA.css'

const RMADetailLoader = ({ moduleData }) => {
  const { loading } = { ...moduleData }
  return (
    <>
      <RMADetailLoaderContainer>
        <DetailsLoader key="detailsLoader" loading={loading} />
      </RMADetailLoaderContainer>
    </>
  )
}

export default RMADetailLoader
